import React, { Component } from 'react'
import ReactSelect from 'react-select'
import axios from 'axios';
import {axiosEH} from '../common/functions'
import jwtUser from '../../jwtUser';


export default class DeleteClass extends Component {
  constructor() {
    super()
    this.state = {
      className: '',
      classList: [],
      statusMsg: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    let url = process.env.REACT_APP_BASEURL + '/userclasses/deleteclass';
    const user = jwtUser(); // get user token

    // inputs required
    if (this.state.className == '') {
      this.setState({ statusMsg: `input className` })
      return;
    }

    axios.post(url, {
      username: user.username,
      className: this.state.className,
    }, { headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {
        //console.log("res.data:", res.data, this.state.className);
        this.setState({
          statusMsg: res.data,
        })
        if (res.data == this.state.className) {
          sessionStorage.removeItem("classList");
          window.location.reload();
        }
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  }

  componentDidMount() {
    let classList = JSON.parse(sessionStorage.getItem("classList"));
    if (classList !== null) {
      this.setState(() => {
        return {
          classList: classList.map(e=> e.className)
        }
      })
    }
  }

  render() {
    return (
      <section className="login-form is-medium mx-5">
        <div className="select is-danger" style={{width:'80%'}}>
            <select name='className' onChange={this.handleChange} >
                <option >Class list ...</option>
                {this.state.classList.map((option, index) => {
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
          </div>

        <button className="button is-success" onClick={this.handleSubmit}>
          -Class
        </button>
        <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}